import axios from 'axios'
import { Message } from 'element-ui'

// 序列化参数
function objectToFormData (obj, rootName, ignoreList) {
  const result = {}

  function recurse (src, prop) {
    const { toString } = Object.prototype
    if (toString.call(src) === '[object Object]') {
      let isEmpty = true
      // eslint-disable-next-line no-restricted-syntax
      for (const p in src) {
        isEmpty = false
        if (src[p] || src[p] === 0 || src[p] === '') {
          recurse(src[p], prop ? `${prop}[${p}]` : p)
        }
      }
      if (isEmpty && prop) {
        result[prop] = {}
      }
    } else if (toString.call(src) === '[object Array]') {
      const len = src.length
      if (len > 0) {
        src.forEach((item, index) => {
          recurse(item, prop ? `${prop}[${index}]` : index)
        })
      }
    } else {
      result[prop] = src
    }
  }

  recurse(obj, '')

  return result
}

let baseURL = process.env.VUE_APP_BASE_API

if (window.location.protocol === 'https:') {
  baseURL = `${window.location.protocol}//${window.location.hostname}`
}
// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL, // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

// request interceptor
service.interceptors.request.use((config) => {
  // 是否需要序列化数据
  const { processData } = config
  if (processData) {
    if (config.data) {
      // eslint-disable-next-line no-param-reassign
      config.params = config.data
      // eslint-disable-next-line no-param-reassign
      delete config.data
    }
    // eslint-disable-next-line no-param-reassign
    config.params = objectToFormData(config.params)
  }
  if (config.method.toUpperCase() === 'POST') {
    const FormData = new window.FormData()
    if (config.params) {
      // eslint-disable-next-line no-param-reassign
      config.data = config.data || config.params
      // eslint-disable-next-line no-param-reassign
      delete config.params
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const key in config.data) {
      FormData.append(key, config.data[key])
    }
    // eslint-disable-next-line no-param-reassign
    config.data = FormData
  }
  return config
}, (error) => {
  // do something with request error
  console.error(error) // for debug
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */(response) => {
    switch (response.data.code) {
      case 1002:// 跳登录
        window.location.href = `${window.location.origin}/#/login`
        break
      case 0: // 请求成功
        return response.data
      case 20001: // 警告
        return response.data
      default: // 请求失败
        if (response.headers['content-type'] === 'application/force-download') {
          return response.data
        }
        Message({
          message: response.data.message || '网络错误，请稍后再试', type: 'error', duration: 2 * 1000
        })
        return Promise.reject(response.data.message || '网络错误，请稍后再试')
    }
    return response.data
  }, (error) => {
    console.error(error, 'error') // for debug
    Message({
      message: error.msg || error.message, type: 'error', duration: 2 * 1000
    })
    return Promise.reject(error)
  })

export default service
